import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { installGlobalErrorReporting } from './lib/report-error.js';
import { migrateLegacySession } from './lib/api.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import './index.css';
import 'flag-icons/css/flag-icons.min.css';

// Catches errors thrown outside React's render cycle, which an ErrorBoundary cannot see.
installGlobalErrorReporting();

const boot = () =>
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  );

// A user signed in on the previous build holds `tl_access`/`tl_refresh` in localStorage and no
// cookies. That session is exchanged for cookies BEFORE the first render, because Dashboard, Alerts
// and Billing redirect with `replace` when not signed in - rendering first would strand an existing
// user on /auth, history erased, even though their refresh token was still perfectly valid.
//
// It is a no-op (no network) for everyone else, and the fetch is timeout-bounded, so this can delay
// the paint but never prevent it.
void migrateLegacySession().finally(boot);
